import React, { useLayoutEffect } from 'react';
import FormContainer from 'components/LoanForm/FormContainer';
import Button from 'components/Button';
import { FlowComponentType } from 'routes/types';
import { useVerificationSteps, VerificationReturningFlow } from 'components/Verification/verificationSteps';
import { SetupAccountResult } from 'enums/FlowNextResults';

import styles from './SetupAccount.module.scss';

const SetupAccount = ({ handleNext }: FlowComponentType) => {
  const { stepsCompleted } = useVerificationSteps();

  useLayoutEffect(() => {
    if (stepsCompleted) handleNext(SetupAccountResult.AllStepsCompleted);
  }, []);

  return (
    <div className={styles.container}>
      <FormContainer
        title="Finish setting up your account"
        subtitle={<p>Just a few steps left until you're officially part of the Plannery community!</p>}
      >
        <VerificationReturningFlow />
        <Button className={styles.button} onClick={handleNext}>
          Next
        </Button>
      </FormContainer>
    </div>
  );
};

export default SetupAccount;
